import React from 'react'
import { Button } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  onClick: () => void
}

/**
 * Button component to ignore access request.
 */
const OwnerAccessRequestIgnoreButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useCustomTranslation()

  return (
    <Button color="inherit" variant="outlined" sx={{ color: 'shades.shade01', borderColor: 'shades.shade01' }} onClick={onClick}>
      {t('dashboard.access-request-dialog.button.ignore')}
    </Button>
  )
}

export default OwnerAccessRequestIgnoreButton
